import './registrationInchargeHomePage.css';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import ApexChart from "../../../preregcamps/homepage/charts";
import ListIcon from '../../../images/ListIcon.png';
import manageIcon from '../../../images/manageIcon.png';
import pendingIcon from '../../../images/pendingIcon.png';
import resolve from '../../../images/resolved.png';
import unresolve from '../../../images/unresolved.png';
import React, { useState, useEffect } from "react";

import jwt from 'jwt-decode';
import { GET_USER_DETAILS} from '../../../common/URLs';
import { ROLES } from '../../../common/constants';
import { Navigate } from 'react-router-dom';
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { Container, Row, Col, Stack, Table } from 'react-bootstrap';
import { getLocalStorageItem } from '../../../common/localStorageUtils';
import { PROD } from '../../../common/constants';
import apiClient from '../../../axios';
export let userDataScrutiny;
function RegistrationInchageHomePage() {
  const [emailId, setEmailId] = useState();
  const [userId, setUserId] = useState();
  const [userDetails, setUserDetails] = useState();
  const [roles, setRoles] = useState();
    useEffect(() => {
      if (getLocalStorageItem('id_token')) {
        const decoded = jwt(getLocalStorageItem('id_token'));
        const email= decoded.emails?.[0];
        setEmailId(email);   
      }
    }, [getLocalStorageItem('id_token')]);
    useEffect(() => {
      if (emailId) {
        getUserDetails();
      }
    }, [emailId]);
    useEffect(() => {
      if (userDetails) {
        const role = userDetails.user.userRoles?.[0].roleName;
        const userid = userDetails.user.id;
        userDataScrutiny = userDetails;
        setUserId(userid);
        setRoles(role);
      }
    }, [userDetails]);
    function getUserDetails() {
      apiClient
        .post(GET_USER_DETAILS,
          {
          "emailAddress": emailId,
          "userRole": getLocalStorageItem('role'),
          },
          {
            headers: {
              Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
            }
          }, null
        )
        .then((response) => {
          setUserDetails(response.data);
        })
        .catch(function (error) {
          console.log(error);
        });
    }
const pendingAppCount = userDetails?.applicationStatusCount?.[0]?.count;
const pendingClarificationsCount = userDetails?.applicationStatusCount?.[2]?.count;
const pendingRejectionsCount = userDetails?.applicationStatusCount?.[1]?.count;
const totalOnboarded = userDetails?.applicationStatusCount?.[3]?.count;
const totalRejections = userDetails?.applicationStatusCount?.[4]?.count;
const activeApplications = userDetails?.stakeHolderStatusCounts[0]?.count;
const shorlisted = userDetails?.stakeHolderStatusCounts[1]?.count;
const waitlisted = userDetails?.stakeHolderStatusCounts[2]?.count;
 const newRegistrations = userDetails?.stakeHolderStatusCounts[3]?.count;
 const inactiveApplications = userDetails?.stakeHolderStatusCounts[4]?.count;
const leadScrutinizerCount = userDetails?.userTypeCounts[1]?.count;
const scrutinizerCount = userDetails?.userTypeCounts[2]?.count;
const assistantCount = userDetails?.userTypeCounts[0]?.count;
const fname = userDetails?.user.firstname;
const mname = userDetails?.user.middlename;
const lname = userDetails?.user.lastname;

  function viewAllWaitlistedStakeholders(e){
    e.preventDefault();
      navigate("/registrationHome/dashboard/viewAllStakeholders", { state: { status: "Waitlisted" } });
  }
  function viewAllShortlistedStakeholders(e){
    e.preventDefault();
      navigate("/registrationHome/dashboard/viewAllStakeholders", { state: { status: "Shortlisted" } });
  }
  function viewAllPreRegStakeholders(e){
    e.preventDefault();
      navigate("/registrationHome/dashboard/viewAllStakeholders", { state: { status: "Pre_Registration_Initiated" } });
  }
  function viewAllStakeholders(e){
    e.preventDefault();
      navigate("/registrationHome/dashboard/viewAllStakeholders", { state: { status: "All" } });
    }
    function viewAllInactiveStakeholders(e) {
        e.preventDefault();
        navigate("/registrationHome/dashboard/viewAllStakeholders", { state: { status: "Inactive" } });
    }
  // function viewAllPendingApplications(e){
  //   e.preventDefault();
  //   navigate("/registrationHome/dashboard/viewAllAssignedStakeholders" , { state: { userid :userId } });
  // }
  // function viewAllClarifications(e){
  //   e.preventDefault();
  //   navigate("/registrationHome/dashboard/viewAllClarifications" , { state: { userid :userId } });
  // }
  // function viewAllPendingRejections(e){
  //   e.preventDefault();
  //   navigate("/registrationHome/dashboard/viewAllPendingRejections" , { state: { userid :userId } });
  // }
  function viewAllRejections(e){
    e.preventDefault();
    navigate("/registrationHome/dashboard/viewAllStakeholderStatus" , { state: { userid :userId ,status: "Rejected"} });
  }
  function viewAllOnboarding(e){
    e.preventDefault();
    navigate("/registrationHome/dashboard/viewAllStakeholderStatus" , { state: { userid :userId , status: "Approved"} });
  }
  function viewAllLeadScrutinizers(e){
    e.preventDefault();
      navigate("/registrationHome/dashboard/viewAllScrutinizers", { state: { userid: userId, role: ROLES.LeadRegScrutinizer } });
  }
  function viewAllScrutinizers(e){
    e.preventDefault();
    navigate("/registrationHome/dashboard/viewAllScrutinizers" , { state: { userid :userId, role: ROLES.RegistrationScruitnizer}});
  }
  function viewAllRegAssistant(e){
    e.preventDefault();
    navigate("/registrationHome/dashboard/viewAllScrutinizers" , { state: { userid :userId, role: ROLES.RegAssistant}});
  }
  function onVerifyClick(e){
    e.preventDefault();
    navigate("/registrationHome/dashboard/verifyStakeholderDocuments");
  }
  const navigate = useNavigate();
  const location = useLocation();
  return (
      <div className="Home-page">
          <div>
              <Container fluid>
                  <Row>
                  {!PROD &&  <p style={{textAlign:"center", fontSize:"2vh"}}>REG39</p>}

                      <Col xs={12} md={4} >
                          <Stack direction="verticle">
                              <div className="apex-card">
                                  <h1 className="apex-card-text">Registered Stakeholders</h1>
                                  <ApexChart></ApexChart>
                              </div>
                          </Stack>
                      </Col>
                      <Col xs={6} md={4} >
                              <div className="onboarded-card">
                                  <a href='' onClick={(e) => viewAllOnboarding(e)} style={{ color: '#005BAA', marginLeft: '16vw', marginTop: '0vh', position: 'absolute' }}>View all </a>
                                  <Typography style={{ fontWeight: 800, color: '#000000', fontSize: '1rem', textAlign: 'left', marginTop: '1vh' }}>{totalOnboarded}</Typography>
                                  <Typography style={{ fontWeight: 500, color: '#000000', fontSize: '1rem', textAlign: 'left', marginTop: '4vh' }}>Total Onboarded</Typography>
                          </div>
                          <div className="onboarded-card">
                              <a href='' onClick={(e) => viewAllStakeholders(e)} style={{ color: '#005BAA', marginLeft: '16vw', marginTop: '0vh', position: 'absolute' }}>View all </a>
                              <Typography style={{ fontWeight: 800, color: '#000000', fontSize: '1rem', textAlign: 'left', marginTop: '1vh' }}>{activeApplications}</Typography>
                              <Typography style={{ fontWeight: 500, color: '#000000', fontSize: '1rem', textAlign: 'left', marginTop: '4vh' }}>Active Applications</Typography>
                          </div>
                      </Col>
                      <Col xs={6} md={4} >
                          <div className="onboarded-card">
                              <a href='' onClick={(e) => viewAllRejections(e)} style={{ color: '#005BAA', marginLeft: '16vw', marginTop: '0vh', position: 'absolute' }}>View all </a>
                              <Typography style={{ fontWeight: 800, color: '#000000', fontSize: '1rem', textAlign: 'left', marginTop: '1vh' }}>{totalRejections}</Typography>
                              <Typography style={{ fontWeight: 500, color: '#000000', fontSize: '1rem', textAlign: 'left', marginTop: '4vh' }}>Total Rejections</Typography>
                          </div>
                          <div className="onboarded-card">
                              <a href='' onClick={(e) => viewAllInactiveStakeholders(e)} style={{ color: '#005BAA', marginLeft: '16vw', marginTop: '0vh', position: 'absolute' }}>View all </a>
                              <Typography style={{ fontWeight: 800, color: '#000000', fontSize: '1rem', textAlign: 'left', marginTop: '1vh' }}>{inactiveApplications}</Typography>
                              <Typography style={{ fontWeight: 500, color: '#000000', fontSize: '1rem', textAlign: 'left', marginTop: '4vh' }}>Inactive Applications</Typography>
                          </div>
                      </Col>
                          <div className="profile-card" style={{display:"none"}}>
              <h1 className="profile-card-text">Profile</h1>
              <p>Name : {fname} {mname} {lname}</p>
              <p>Email : {emailId}</p>
               </div>           
                      <Col xs={6} md={4}>
                          <div className="onboarded-card">
                              <a href='' onClick={(e) => viewAllPreRegStakeholders(e)} style={{ color: '#005BAA', marginLeft: '16vw', marginTop: '0vh', position: 'absolute' }}>View all </a>
                              <Typography style={{ fontWeight: 800, color: '#000000', fontSize: '1rem', textAlign: 'left', marginTop: '1vh' }}>{newRegistrations}</Typography>
                              <Typography style={{ fontWeight: 500, color: '#000000', fontSize: '1rem', textAlign: 'left', marginTop: '4vh' }}>New Registrations</Typography>
                          </div>
                      </Col>
                      <Col xs={6} md={4}>
                          <div className="onboarded-card">
                              <a href='' onClick={(e) => viewAllShortlistedStakeholders(e)} style={{ color: '#005BAA', marginLeft: '16vw', marginTop: '0vh', position: 'absolute' }}>View all </a>
                              <Typography style={{ fontWeight: 800, color: '#000000', fontSize: '1rem', textAlign: 'left', marginTop: '1vh' }}>{shorlisted}</Typography>
                              <Typography style={{ fontWeight: 500, color: '#000000', fontSize: '1rem', textAlign: 'left', marginTop: '4vh' }}>Shortlisted</Typography>
                          </div>
                      </Col>
                      <Col xs={6} md={4}>
                          <div className="onboarded-card">
                              <a href='#' onClick={(e) => viewAllWaitlistedStakeholders(e)} style={{ color: '#005BAA', marginLeft: '16vw', marginTop: '0vh', position: 'absolute' }}>View all </a>
                              <Typography style={{ fontWeight: 800, color: '#000000', fontSize: '1rem', textAlign: 'left', marginTop: '1vh' }}>{waitlisted}</Typography>
                              <Typography style={{ fontWeight: 500, color: '#000000', fontSize: '1rem', textAlign: 'left', marginTop: '4vh' }}>Waitlisted</Typography>
                          </div>
                      </Col>
                      <Col xs={6} md={4}>
                          <div className="onboarded-card">
                              <a href='#' onClick={(e) => viewAllLeadScrutinizers(e)} style={{ color: '#005BAA', marginLeft: '16vw', marginTop: '0vh', position: 'absolute' }}>View all </a>
                              <Typography style={{ fontWeight: 800, color: '#000000', fontSize: '1rem', textAlign: 'left', marginTop: '1vh' }}>{leadScrutinizerCount}</Typography>
                              <Typography style={{ fontWeight: 500, color: '#000000', fontSize: '1rem', textAlign: 'left', marginTop: '4vh' }}>Lead Scrutinizers Onboarded</Typography>
                          </div>
                      </Col>
                      <Col xs={6} md={4}>
                          <div className="onboarded-card">
                              <a href='#' onClick={(e) => viewAllScrutinizers(e)} style={{ color: '#005BAA', marginLeft: '16vw', marginTop: '0vh', position: 'absolute' }}>View all </a>
                              <Typography style={{ fontWeight: 800, color: '#000000', fontSize: '1rem', textAlign: 'left', marginTop: '1vh' }}>{scrutinizerCount}</Typography>
                              <Typography style={{ fontWeight: 500, color: '#000000', fontSize: '1rem', textAlign: 'left', marginTop: '4vh' }}>Scrutinizers Onboarded</Typography>
                          </div>
                      </Col>
                      <Col xs={6} md={4}>
                          <div className="onboarded-card">
                              <a href='#' onClick={(e) => viewAllRegAssistant(e)} style={{ color: '#005BAA', marginLeft: '16vw', marginTop: '0vh', position: 'absolute' }}>View all </a>
                              <Typography style={{ fontWeight: 800, color: '#000000', fontSize: '1rem', textAlign: 'left', marginTop: '1vh' }}>{assistantCount ? assistantCount : 0}</Typography>
                              <Typography style={{ fontWeight: 500, color: '#000000', fontSize: '1rem', textAlign: 'left', marginTop: '4vh' }}>Assistants Onboarded</Typography>
                          </div>
                      </Col>
                      <Col xs={6} md={4}>
                          <div className="onboarded-card">
                              <a href='#' onClick={(e) => onVerifyClick(e)} style={{ color: '#005BAA', marginLeft: '16vw', marginTop: '0vh', position: 'absolute' }}>Verify </a>
                              <Typography style={{ fontWeight: 800, color: '#000000', fontSize: '1rem', textAlign: 'left', marginTop: '1vh' }}>
                                &nbsp;
                                </Typography>
                              <Typography style={{ fontWeight: 500, color: '#000000', fontSize: '1rem', textAlign: 'left', marginTop: '4vh' }}>Stakeholder Documents Verification</Typography>
                          </div>
                      </Col>
                      {/* <Col xs={6} md={4}>
                          <div className="onboarded-card">
                              <a href='#' onClick={(e) => viewAllPendingApplications(e)} style={{ color: '#005BAA', marginLeft: '16vw', marginTop: '0vh', position: 'absolute' }}>View all </a>
                              <Typography style={{ fontWeight: 800, color: '#000000', fontSize: '1rem', textAlign: 'left', marginTop: '1vh' }}>{pendingAppCount}</Typography>
                              <Typography style={{ fontWeight: 500, color: '#000000', fontSize: '1rem', textAlign: 'left', marginTop: '4vh' }}>Pending Approvals</Typography>
                          </div>
                      </Col>
                      <Col xs={6} md={4}>
                          <div className="onboarded-card">
                              <a href='#' onClick={(e) => viewAllPendingRejections(e)} style={{ color: '#005BAA', marginLeft: '16vw', marginTop: '0vh', position: 'absolute' }}>View all </a>
                              <Typography style={{ fontWeight: 800, color: '#000000', fontSize: '1rem', textAlign: 'left', marginTop: '1vh' }}>{pendingRejectionsCount}</Typography>
                              <Typography style={{ fontWeight: 500, color: '#000000', fontSize: '1rem', textAlign: 'left', marginTop: '4vh' }}>Pending Rejections</Typography>
                          </div>
                      </Col>
                      <Col xs={6} md={4}>
                          <div className="onboarded-card">
                              <a href='#' onClick={(e) => viewAllClarifications(e)} style={{ color: '#005BAA', marginLeft: '16vw', marginTop: '0vh', position: 'absolute' }}>View all </a>
                              <Typography style={{ fontWeight: 800, color: '#000000', fontSize: '1rem', textAlign: 'left', marginTop: '1vh' }}>{pendingClarificationsCount}</Typography>
                              <Typography style={{ fontWeight: 500, color: '#000000', fontSize: '1rem', textAlign: 'left', marginTop: '4vh' }}>Pending Clarifications</Typography>
                          </div>
                      </Col> */}
                  </Row>
              </Container>
              </div>
    </div>
  );
}
export default RegistrationInchageHomePage;

